import { useCallback } from 'react';
import LogoImg from '../../../screens/chatbotWeb/images/isa2.png';

/**
 * SetupSessionInterface Component
 *
 * This component handles chat session interface setup logic extracted from useChatbotWeb hook.
 * It manages different session states and sets up appropriate UI elements based on:
 * - Session status
 * - User permissions
 * - Chat responsibilities
 * - User access levels
 */
const useSetupSessionInterface = ({
    // State setters
    setMessages,
    setOptions,
    setShowOptions,
    setShowInputBar,
    setNewTipoChat,
    setLastTypeChat,

    // Current values
    profile,
    chatProfile,
    isMountedRef,
    selectedSessionId,

    // Options arrays
    defaultOptions,
    defaultOptionsNew,
    ausenciaDefault,
    fetchAreasForCommunication,
    fetchRegionalCommunication,
    fetchCommunicationBySession,
    mudarStatusSessao,

    // Functions
    handleSelectOption,
    //
    setLoadingPage,
}) => {
    const setupSessionInterface = useCallback(
        async (session, chatResponsavel) => {
            if (!isMountedRef.current) return; // Exit early if component is unmounted

            let name = profile.pess_nome;
            const nomeUsuario = `${profile.pess_nome}-${profile.pess_id_pessoa}`;
            // Default options
            // Check various conditions based on session status and user permissions
            // Default case

            setShowOptions(false);
            setOptions([]);

            if (session.usuario.id === profile.pess_id_pessoa && session.status === 'AUSENCIA_EM_FINALIZACAO') {
                setMessages((prev) => [
                    ...prev,
                    {
                        remetente: 'ISA',
                        texto:
                            'Olá ' +
                            name +
                            ', Informe o motivo da sua ausência, se puder, anexe o atestado médico ou qualquer outro documento que comprove-a. Após informar, finalize o atendimento:',
                        avatar: LogoImg,
                    },
                ]);
                setNewTipoChat('ausencia_finalizar');
                setOptions([
                    { key: 'informar_ausencia', label: 'Finalizar o atendimento' },
                    { key: 'finalizar', label: 'Concluir mais tarde' },
                ]);
                setShowOptions(true);
                setShowInputBar(true);
                return;
            }

            if (session.usuario.id === profile.pess_id_pessoa && session.status === 'AUSENCIA_PENDENTE') {
                setMessages((prev) => [
                    ...prev,
                    {
                        remetente: 'ISA',
                        texto:
                            'Olá ' +
                            name +
                            ', sobre a ausência, seu tipo de contrato é mensal? escolha uma das opções abaixo:',
                        avatar: LogoImg,
                    },
                ]);
                setNewTipoChat('envio_de_atestados');
                setOptions(ausenciaDefault);
                setShowOptions(true);
                setShowInputBar(false);
                return;
            }

            if (session.usuario.id === profile.pess_id_pessoa && session.status === 'PENDENTE') {
                setMessages((prev) => [
                    ...prev,
                    {
                        remetente: 'ISA',
                        //texto: 'Olá ' + name + ', converse comigo utilizando a caixa de texto abaixo:',
                        texto:
                            'Olá ' +
                            name +
                            '! Seja bem vindo ao chat do Grupo Altum. Para continuar, selecione uma das opções abaixo ou digite claramente o que você precisa:',
                        avatar: LogoImg,
                    },
                ]);

                setNewTipoChat('voltar_chat');
                setOptions(defaultOptionsNew);
                setShowOptions(true);
                setShowInputBar(true);
                return;
            }

            //COMUNICACAO_RESPONSAVEL_PENDENTE

            if (session.usuario.id === profile.pess_id_pessoa && session.status === 'COMUNICACAO_PENDENTE') {
                setMessages((prev) => [
                    ...prev,
                    {
                        remetente: 'ISA',
                        texto: 'Ok, por favor, click em preenche o formulário ou em Cancelar Comunicação Interna',
                        avatar: LogoImg,
                        isOption: false,
                    },
                ]);
                setNewTipoChat('comunicacao_interna_iniciar');
                setOptions([
                    { key: 'comunicacao_interna_iniciar', label: 'Continuar com a Comunicação Interna' },
                    { key: 'comunicacao_interna_cancelar', label: 'Cancelar Comunicação Interna' },
                ]);

                setShowOptions(true);
                setShowInputBar(false);
                return;
            }

            if (
                chatResponsavel.id_usuario === profile.pess_id_pessoa &&
                chatProfile.nivel_acesso &&
                session.status === 'ATENDIMENTO_AUSENCIA_EM_ANDAMENTO'
            ) {
                if (!isMountedRef.current) return;
                setOptions([{ key: 'finalizar_atendimento_ausencia', label: 'Encerrar o atendimento ausência' }]);
                setShowOptions(true);
                setShowInputBar(true);
                setNewTipoChat(session.status);
                return;
            }

            if (
                chatResponsavel.id_usuario === profile.pess_id_pessoa &&
                chatProfile.nivel_acesso &&
                session.status === 'COMUNICACAO_AT_HUMANDO'
            ) {
                if (!isMountedRef.current) return;

                setOptions([
                    //{ key: 'ver_comunicacao_interna', label: 'Ver Comunicação Interna' },
                    { key: 'finalizar_atendimento_comunicacao_interna', label: 'Encerrar a Comunicação Interna' },
                ]);
                setShowOptions(true);
                setShowInputBar(true);
                setNewTipoChat('conversar_comunicacao_interna');
                return;
            }

            if (
                chatResponsavel.id_usuario === profile.pess_id_pessoa &&
                chatProfile.nivel_acesso &&
                session.status === 'EMPRESTIMO_EM_ATEND'
            ) {
                if (!isMountedRef.current) return;
                setNewTipoChat('conversar_emprestimo');
                setOptions([
                    //{ key: 'ver_comunicacao_interna', label: 'Ver Comunicação Interna' },
                    { key: 'finalizar_atendimento_emprestimo', label: 'Encerrar o atendimento' },
                ]);
                setShowOptions(true);
                setShowInputBar(true);

                return;
            }

            if (
                chatResponsavel.id_usuario === profile.pess_id_pessoa &&
                chatProfile.nivel_acesso &&
                session.status === 'PENDENTE_HUMANO'
            ) {
                if (!isMountedRef.current) return;
                setOptions([{ key: 'finalizar_atendimento', label: 'Encerrar o atendimento' }]);
                setShowOptions(true);
                setShowInputBar(true);
                setNewTipoChat(session.status);
                return;
            }

            if (
                profile.pess_id_pessoa !== session.usuario.id &&
                chatProfile.nivel_acesso !== null &&
                (session.status === 'AUSENCIA_EM_FINALIZACAO' ||
                    session.status === 'AUSENCIA_PENDENTE' ||
                    session.status === 'COMUNICACAO_PENDENTE' ||
                    session.status === 'COMUNICACAO_ANDAMENTO_TIPO' ||
                    session.status === 'COMUNICACAO_ANDAMENTO_D_INICIAL' ||
                    session.status === 'COMUNICACAO_ANDAMENTO_D_FINAL' ||
                    session.status === 'COMUNICACAO_ANDAMENTO_COMENTARIO' ||
                    session.status === 'COMUNICACAO_ANDAMENTO_CID' ||
                    session.status === 'COMUNICACAO_ANDAMENTO_D_INICIAL_ALL' ||
                    session.status === 'COMUNICACAO_ANDAMENTO_REGIONAL' ||
                    session.status === 'COMUNICACAO_ANDAMENTO_AREA' ||
                    session.status === 'COMUNICACAO_ANDAMENTO_ARQUIVO' ||
                    session.status === 'COMUNICACAO_ANDAMENTO_DASHBOARD')
            ) {
                setOptions([{ key: 'finalizar', label: 'Sair' }]);
                setShowOptions(false);
                setShowInputBar(false);
                setNewTipoChat(session.status);

                if (session.status === 'COMUNICACAO_ANDAMENTO_DASHBOARD') {
                    setMessages((prev) => [
                        ...prev,
                        {
                            remetente: 'ISA',
                            texto: 'Essa sessão está sendo atendida através do Painel Sagris.',
                            avatar: LogoImg,
                            isOption: false,
                        },
                    ]);
                    return;
                }

                setMessages((prev) => [
                    ...prev,
                    {
                        remetente: 'ISA',
                        texto: 'Essa sessão não necessita de atendimento ainda',
                        avatar: LogoImg,
                        isOption: false,
                    },
                ]);

                return;
            }

            if (
                profile.pess_id_pessoa !== session.usuario.id &&
                chatProfile.nivel_acesso !== null &&
                session.status === 'PENDENTE'
            ) {
                setOptions([{ key: 'finalizar', label: 'Sair' }]);
                setShowOptions(false);
                setShowInputBar(false);
                setNewTipoChat(session.status);
                setMessages((prev) => [
                    ...prev,
                    {
                        remetente: 'ISA',
                        texto: 'Essa sessão não necessita de atendimento ainda',
                        avatar: LogoImg,
                        isOption: false,
                    },
                ]);
                return;
            }

            if (
                session.usuario.id !== profile.pess_id_pessoa &&
                chatResponsavel.id_usuario !== profile.pess_id_pessoa &&
                chatProfile.nivel_acesso !== null &&
                (session.status === 'ATENDIMENTO_AUSENCIA_EM_ANDAMENTO' ||
                    session.status === 'PENDENTE_HUMANO' ||
                    session.status === 'COMUNICACAO_AT_HUMANDO' ||
                    session.status === 'EMPRESTIMO_EM_ATEND')
            ) {
                setOptions([{ key: 'finalizar', label: 'Sair' }]);
                setShowOptions(true);
                setShowInputBar(false);
                setNewTipoChat(session.status);

                setMessages((prev) => [
                    ...prev,
                    {
                        remetente: 'ISA',
                        texto: 'Olá ' + name + ', outra pessoa já esta atendendo essa sessão.',
                        avatar: LogoImg,
                        isOption: false,
                    },
                ]);
                return;
            }

            if (
                (chatProfile.nivel_acesso === null || profile.pess_id_pessoa === session.usuario.id) &&
                (session.status === 'AGUARDANDO_HUMANDO' ||
                    session.status === 'PENDENTE_HUMANO' ||
                    session.status === 'ATENDIMENTO_AUSENCIA_PENDENTE' ||
                    session.status === 'ATENDIMENTO_AUSENCIA_EM_ANDAMENTO' ||
                    session.status === 'COMUNICACAO_RESPONSAVEL_PENDENTE' ||
                    session.status === 'COMUNICACAO_AT_HUMANDO' ||
                    session.status === 'COMUNICACAO_ANDAMENTO_DASHBOARD' ||
                    session.status === 'EMPRESTIMO_EM_ATEND')
            ) {
                if (session.status === 'AGUARDANDO_HUMANDO' || session.status === 'ATENDIMENTO_AUSENCIA_PENDENTE') {
                    setMessages((prev) => [
                        ...prev,
                        {
                            remetente: 'ISA',
                            texto: 'Olá ' + name + ', em breve um atendente entrará em contato, por favor aguarde',
                            avatar: LogoImg,
                            isOption: false,
                        },
                    ]);
                    setOptions([{ key: 'finalizar', label: 'Encerrar o Chat' }]);
                    setShowOptions(false);
                    setShowInputBar(true);
                    setNewTipoChat(session.status);
                    return;
                }

                if (
                    session.status === 'COMUNICACAO_RESPONSAVEL_PENDENTE' ||
                    session.status === 'COMUNICACAO_ANDAMENTO_DASHBOARD'
                ) {
                    setOptions([{ key: 'finalizar', label: 'Encerrar o Chat' }]);
                    setShowOptions(true);
                    setShowInputBar(true);
                    setNewTipoChat(session.status);

                    setNewTipoChat('conversar_comunicacao_interna');

                    if (session.status === 'COMUNICACAO_RESPONSAVEL_PENDENTE') {
                        setMessages((prev) => [
                            ...prev,
                            {
                                remetente: 'ISA',
                                texto: 'Olá ' + name + ', em breve um atendente entrará em contato, por favor aguarde',
                                avatar: LogoImg,
                                isOption: false,
                            },
                        ]);
                        // setOptions([{ key: 'ver_comunicacao_interna', label: 'Ver Comunicação Interna' }]);
                        return;
                    }

                    setOptions([{ key: 'finalizar', label: 'Encerrar o Chat' }]);
                    return;
                }

                if (
                    session.status === 'PENDENTE_HUMANO' ||
                    session.status === 'ATENDIMENTO_AUSENCIA_EM_ANDAMENTO' ||
                    session.status === 'EMPRESTIMO_EM_ATEND'
                ) {
                    setOptions([{ key: 'finalizar', label: 'Encerrar o Chat' }]);
                    setShowOptions(true);
                    setShowInputBar(true);
                    setNewTipoChat(session.status);
                    return;
                }

                if (session.status === 'COMUNICACAO_AT_HUMANDO') {
                    setOptions([{ key: 'finalizar', label: 'Encerrar o Chat' }]);
                    //setOptions([{ key: 'ver_comunicacao_interna', label: 'Ver Comunicação Interna' }]);
                    setShowOptions(true);
                    setShowInputBar(true);
                    setNewTipoChat(session.status);
                    return;
                }
            }

            if (
                profile.pess_id_pessoa !== session.usuario.id &&
                chatProfile.nivel_acesso !== null &&
                session.status === 'ATENDIMENTO_AUSENCIA_PENDENTE'
            ) {
                setOptions([
                    { key: 'atribuir_ausencia', label: 'Interagir com usuário ausência' },
                    { key: 'finalizar', label: 'Sair' },
                ]);
                setShowOptions(true);
                setShowInputBar(false);
                setNewTipoChat(session.status);
                return;
            }

            if (
                profile.pess_id_pessoa !== session.usuario.id &&
                chatProfile.nivel_acesso !== null &&
                (session.status === 'EMPRESTIMO_FINALIZADO' || session.status === 'EMPRESTIMO_PEND_ATEND')
            ) {
                setOptions([
                    { key: 'atribuir_emprestimo', label: 'Interagir com usuário empréstimo' },
                    { key: 'finalizar', label: 'Sair' },
                ]);
                setShowOptions(true);
                setShowInputBar(false);
                setNewTipoChat('conversar_emprestimo');
                return;
            }

            if (
                profile.pess_id_pessoa !== session.usuario.id &&
                chatProfile.nivel_acesso !== null &&
                session.status === 'COMUNICACAO_RESPONSAVEL_PENDENTE'
            ) {
                setOptions([
                    { key: 'atribuir_comunicacao_interna', label: 'Interagir com usuário (comunicação interna)' },
                    //{ key: 'ver_comunicacao_interna', label: 'Ver Comunicação Interna' },
                    { key: 'finalizar', label: 'Sair' },
                ]);
                setShowOptions(true);
                setShowInputBar(false);
                setNewTipoChat('conversar_comunicacao_interna');
                return;
            }

            if (
                profile.pess_id_pessoa !== session.usuario.id &&
                chatProfile.nivel_acesso !== null &&
                session.status === 'AGUARDANDO_HUMANDO'
            ) {
                setOptions([
                    { key: 'atribuir', label: 'Interagir com usuário' },
                    { key: 'finalizar', label: 'Sair' },
                ]);
                setShowOptions(true);
                setShowInputBar(false);
                setNewTipoChat(session.status);
                return;
            }
            /* Interação da interface separada em outra função, fazer o mesmo com o restante */
            if (comunicacaoInternaInteracao(session, profile, name, defaultOptions, defaultOptionsNew)) return;

            if (
                [
                    'FINALIZADO',
                    'CANCELADO',
                    'FINALIZADO_HUMANO',
                    'RESOLVIDO',
                    'RESOLVIDO_HUMANO',
                    'NAO_RESOLVIDO',
                    'NAO_RESOLVIDO_HUMANO',
                    'AUSENCIA_CANCELADA',
                    'ATENDIMENTO_AUSENCIA_CANCELADO',
                    'ATENDIMENTO_AUSENCIA_CONCLUIDO',
                    'AUSENCIA_FINALIZADA',
                    'AUSENCIA_EMERGENCIAL',
                    'AUSENCIA_URGENTE',
                    'AUSENCIA_PROGRAMADA',
                    'COMUNICACAO_CANCELADO',
                    'COMUNICACAO_N_RES_HUMANDO',
                    'COMUNICACAO_FIN_HUMANDO',
                    'COMUNICACAO_RECUSADO_DASHBOARD',
                    'COMUNICACAO_CONCLUIDO_DASHBOARD',
                    'EMPRESTIMO_FINALIZADO',
                    'EMPRESTIMO_FIN_ATEND',
                ].includes(session.status)
            ) {
                setMessages((prev) => [
                    ...prev,
                    {
                        remetente: 'ISA',
                        texto: 'Olá ' + name + ', essa sessão foi finalizada.',
                        avatar: LogoImg,
                        isOption: false,
                    },
                ]);

                setOptions([{ key: 'finalizar', label: 'Encerrar o Chat' }]);
                setShowOptions(false);
                setShowInputBar(false);
                return;
            }
        },
        [
            profile,
            chatProfile,
            defaultOptions,
            defaultOptionsNew,
            ausenciaDefault,
            isMountedRef,
            selectedSessionId,
            fetchAreasForCommunication,
            fetchRegionalCommunication,
            fetchCommunicationBySession,
            handleSelectOption,
            setMessages,
            setOptions,
            setShowOptions,
            setShowInputBar,
            setNewTipoChat,
            setLastTypeChat,
        ],
    );

    const comunicacaoInternaInteracao = useCallback(
        async (session, profile, name, defaultOptions, defaultOptionsNew) => {
            if (
                (session.usuario.id === profile.pess_id_pessoa && session.status) === 'COMUNICACAO_ANDAMENTO_INTERACAO'
            ) {
                await handleSelectOption('comunicacao_interna_interacao_sim', 'Selecionando a Regional');
                await mudarStatusSessao('COMUNICACAO_ANDAMENTO_REGIONAL');
                return true;
            }

            if ((session.usuario.id === profile.pess_id_pessoa && session.status) === 'COMUNICACAO_ANDAMENTO_AREA') {
                setMessages((prev) => [
                    ...prev,
                    {
                        remetente: 'ISA',
                        //texto: 'Olá ' + name + ', continue o preenchimento da comunicação interna a partir daqui:',
                        texto: 'Olá! Continue o preenchimento da comunicação interna a partir daqui:',
                        avatar: LogoImg,
                    },
                ]);
                setNewTipoChat('iniciar_comunicacao_interna');
                const areaOptions = await fetchAreasForCommunication();

                setOptions(areaOptions);
                setShowOptions(true);
                setShowInputBar(false);
                return true;
            }

            if (
                session.usuario.id === profile.pess_id_pessoa &&
                (session.status === 'COMUNICACAO_ANDAMENTO_TIPO' ||
                    session.status === 'COMUNICACAO_ANDAMENTO_D_INICIAL' ||
                    session.status === 'COMUNICACAO_ANDAMENTO_D_FINAL' ||
                    session.status === 'COMUNICACAO_ANDAMENTO_COMENTARIO' ||
                    session.status === 'COMUNICACAO_ANDAMENTO_CID' ||
                    session.status === 'COMUNICACAO_ANDAMENTO_D_INICIAL_ALL' ||
                    session.status === 'COMUNICACAO_ANDAMENTO_REGIONAL' ||
                    session.status === 'COMUNICACAO_ANDAMENTO_AREA' ||
                    session.status === 'COMUNICACAO_ANDAMENTO_ARQUIVO')
            ) {
                setMessages((prev) => [
                    ...prev,
                    {
                        remetente: 'ISA',
                        texto: 'Olá! Continue o preenchimento da comunicação interna a partir daqui:',
                        //texto: 'Olá ' + name + ', continue o preenchimento da comunicação interna a partir daqui:',
                        avatar: LogoImg,
                    },
                ]);

                setNewTipoChat('comunicacao_interna');

                // Fetch communication data by session
                const communicationData = await fetchCommunicationBySession(session.id);

                let area = communicationData.cmit_area ?? '';
                let regional = communicationData.cmit_regional ?? '';

                if (communicationData && area !== 'Mudar o Tipo') {
                    // Filter and format the area data
                    const areaKey = `comunicacao_interna_interacao_area_${area
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                        .replace(/ç/gi, 'c')
                        .replace(/[^a-z0-9\s]/gi, '')
                        .replace(/\s+/g, '_')
                        .toLowerCase()}`;

                    // Store the area key for later use
                    setLastTypeChat(areaKey);

                    // Call handleSelectOption to process the area selection and continue the flow

                    switch (session.status) {
                        case 'COMUNICACAO_ANDAMENTO_D_INICIAL_ALL':
                            await handleSelectOption('comunicacao_interna_interacao_data_inicio', 'Data Inícial');
                            await mudarStatusSessao('COMUNICACAO_ANDAMENTO_D_INICIAL_ALL');
                            return true;
                        case 'COMUNICACAO_ANDAMENTO_REGIONAL':
                            await handleSelectOption('comunicacao_interna_interacao_sim', 'Selecionando a Regional');
                            await mudarStatusSessao('COMUNICACAO_ANDAMENTO_REGIONAL');
                            return true;

                        case 'COMUNICACAO_ANDAMENTO_D_INICIAL':
                            await handleSelectOption(
                                'comunicacao_interna_interacao_atestados_data_inicio_atestados',
                                'Data Inícial',
                            );
                            await mudarStatusSessao('COMUNICACAO_ANDAMENTO_D_INICIAL');
                            return true;

                        case 'COMUNICACAO_ANDAMENTO_D_FINAL':
                            await handleSelectOption('comunicacao_interna_interacao_atestados_data_fim', 'Data Final');
                            await mudarStatusSessao('COMUNICACAO_ANDAMENTO_D_FINAL');
                            return true;

                        case 'COMUNICACAO_ANDAMENTO_COMENTARIO':
                            await handleSelectOption(
                                'comunicacao_interna_interacao_adicionar_comentarios',
                                'Data Inícial',
                            );
                            await mudarStatusSessao('COMUNICACAO_ANDAMENTO_COMENTARIO');
                            return true;

                        case 'COMUNICACAO_ANDAMENTO_CID':
                            await handleSelectOption('comunicacao_interna_interacao_adicionar_cid', 'CID');
                            await mudarStatusSessao('COMUNICACAO_ANDAMENTO_CID');
                            return true;

                        case 'COMUNICACAO_ANDAMENTO_AREA':
                            await handleSelectOption('comunicacao_interna_interacao_area', area);
                            await mudarStatusSessao('COMUNICACAO_ANDAMENTO_AREA');
                            return true;

                        case 'COMUNICACAO_ANDAMENTO_TIPO':
                            await handleSelectOption(areaKey, area);
                            await mudarStatusSessao('COMUNICACAO_ANDAMENTO_TIPO');
                            return true;

                        case 'COMUNICACAO_ANDAMENTO_ARQUIVO':
                            await handleSelectOption('comunicacao_interna_interacao_anexo', 'Enviar Arquivo');
                            await mudarStatusSessao('COMUNICACAO_ANDAMENTO_ARQUIVO');
                            return true;

                        //case 'COMUNICACAO_ANDAMENTO_DASHBOARD':
                        //    await handleSelectOption('conversar_comunicacao_interna', 'Dashboard Sagris');
                        //    await mudarStatusSessao('COMUNICACAO_ANDAMENTO_DASHBOARD');
                        //    return true;

                        default:
                            await handleSelectOption('comunicacao_interna_interacao_sim', regional);
                            await mudarStatusSessao('COMUNICACAO_ANDAMENTO_REGIONAL');
                            return true;
                    }
                } else {
                    // Fallback: show area options if communication data is not available
                    await handleSelectOption('comunicacao_interna_interacao_sim', 'Selecionando a Regional');
                    await mudarStatusSessao('COMUNICACAO_ANDAMENTO_REGIONAL');
                }

                return true;
            }

            return false;
        },
        [
            fetchAreasForCommunication,
            fetchRegionalCommunication,
            fetchCommunicationBySession,
            handleSelectOption,
            setMessages,
            setNewTipoChat,
            setOptions,
            setShowOptions,
            setShowInputBar,
            setLastTypeChat,
            setLoadingPage,
            mudarStatusSessao,
        ],
    );
    return setupSessionInterface;
};

export default useSetupSessionInterface;
